import React, {createContext, useContext, useEffect, useMemo, useRef, useState} from "react";

import PropTypes from "prop-types";
import {getHashJsonWithoutObject} from "../utils/hashCode";
import {CacheContext} from "../providers/cache";


export function useRequestObject(props){
    let {classType,...rest} = props
    const [cache] = useContext(CacheContext)
    const [state] =  useState(factory(classType,rest))

    function getHashJsonCode(class_,...arg){
        arg[0].class = class_.name
        return  getHashJsonWithoutObject(...arg)

    }
    function factory(class_, ...arg) {
        const  code = getHashJsonCode(class_,...arg)
        const result = cache.get(code)
        if(!!result){
            return result
        }
        const instance = new class_(...arg)
        cache.set(code,instance)
        return instance
    }


    return state
}
